import { VStack } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { BorrowingBaseSummaryCash } from './BorrowingBaseSummaryCash';
import { BorrowingBaseSummaryFacilitySummary } from './BorrowingBaseSummaryFacilitySummary';
import { BorrowingBaseSummaryFinalBorrowingBaseReport } from './BorrowingBaseSummaryFinalBorrowingBaseReport';
import { BorrowingBaseSummaryReceivables } from './BorrowingBaseSummaryReceivables';
import { BorrowingBaseSummarySections } from './utils';
import { BorrowingBaseReportGQLType } from '../../../../../types/dashboard-core-gqlTypes.generated.d';
import { LocalizationProvider } from 'packages/localization';

type BorrowingBaseSummaryWithSingleValueProps = {
  sections: BorrowingBaseSummarySections[];
  borrowingBaseReport: BorrowingBaseReportGQLType;
  creditAgreement: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
};
export const BorrowingBaseSummaryWithSingleValue = ({
  sections,
  borrowingBaseReport,
  creditAgreement,
}: BorrowingBaseSummaryWithSingleValueProps) => {
  const includesSection = (section: BorrowingBaseSummarySections) =>
    _.includes(sections, section);

  const showComparisonAndDifferenceColumns = false;
  const showValueAndReferenceColumnsOnly = false;

  return (
    <LocalizationProvider scope="borrowingBaseSummary">
      <VStack mb="24px" spacing="32px" w="100%">
        {includesSection(BorrowingBaseSummarySections.facilitySummary) && (
          <BorrowingBaseSummaryFacilitySummary
            borrowingBaseReports={{
              minuend: borrowingBaseReport,
            }}
            showComparisonAndDifferenceColumns={
              showComparisonAndDifferenceColumns
            }
            showValueAndReferenceColumnsOnly={showValueAndReferenceColumnsOnly}
          />
        )}
        {includesSection(BorrowingBaseSummarySections.receivables) && (
          <BorrowingBaseSummaryReceivables
            borrowingBaseReports={{
              minuend: borrowingBaseReport,
            }}
            creditAgreement={creditAgreement}
            showComparisonAndDifferenceColumns={
              showComparisonAndDifferenceColumns
            }
            showValueAndReferenceColumnsOnly={showValueAndReferenceColumnsOnly}
          />
        )}
        {includesSection(BorrowingBaseSummarySections.cash) && (
          <BorrowingBaseSummaryCash
            borrowingBaseReports={{
              minuend: borrowingBaseReport,
            }}
            creditAgreement={creditAgreement}
            showComparisonAndDifferenceColumns={
              showComparisonAndDifferenceColumns
            }
            showValueAndReferenceColumnsOnly={showValueAndReferenceColumnsOnly}
          />
        )}
        {includesSection(
          BorrowingBaseSummarySections.finalBorrowingBaseReport,
        ) && (
          <BorrowingBaseSummaryFinalBorrowingBaseReport
            borrowingBaseReports={{
              minuend: borrowingBaseReport,
            }}
            showComparisonAndDifferenceColumns={
              showComparisonAndDifferenceColumns
            }
            showValueAndReferenceColumnsOnly={showValueAndReferenceColumnsOnly}
          />
        )}
      </VStack>
    </LocalizationProvider>
  );
};
